import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiEndpoint } from "../utils/constants";
import { apiFetch } from "@core/index";
import { enqueueSnackbar } from "notistack";

export const useUpdateRole = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (config: {
      payload: { id: number; payloadData: { role: string } };
    }) => {
      const { id, payloadData } = config.payload;
      const response = await apiFetch<{
        statusCode: number;
        message: string;
        data?: unknown;
      }>(`${apiEndpoint}/${id}/role`, {
        method: "PATCH",
        body: payloadData,
      });
      return response;
    },
    onSuccess: () => {
      enqueueSnackbar("Role updated successfully.", {
        variant: "success",
        autoHideDuration: 2000,
      });
      queryClient.invalidateQueries({ queryKey: ["roleManagementList"] });
    },
    onError: (error: Error) => {
      enqueueSnackbar(
        "Failed to update role for user. Error: " + (error ?? ""),
        {
          variant: "error",
          autoHideDuration: 5000,
        },
      );
    },
  });
};
